"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M3 3v18h18V3zm3.5 5h3V7h-3V5.5H11V9H8v1h3v1.5H6.5zm6 10.5H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5zM13 10h3V9h-2V8h2V7h-3V5.5h4.5v6H13zm5 7h-3v1.5h-1.5v-6H18z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M15 14h1.5v1.5H15z"
}, "1")], 'TwentyThreeMpSharp');